import { MutationTree } from 'vuex'

import { QrCode } from '@/models'

import { QrCodesState } from './state'

export const ADD_QRCODE = 'ADD_QRCODE'
export const INCREMENT_QRCODES_QUERY_INDEX = 'INCREMENT_QRCODES_QUERY_INDEX'
export const LOADED_ALL_QRCODES = 'LOADED_ALL_QRCODES'
export const RESET_LOADED_ALL_QRCODES = 'RESET_LOADED_ALL_QRCODES'
export const RESET_QRCODES_QUERY_INDEX = 'RESET_QRCODES_QUERY_INDEX'
export const UPDATE_QRCODES = 'UPDATE_QRCODES'
export const UPDATE_QRCODES_TOTAL = 'UPDATE_QRCODES_TOTAL'

const mutations: MutationTree<QrCodesState> = {
  [ADD_QRCODE] (state, qrCode: QrCode) {
    state.elements.push(qrCode)
  },

  [INCREMENT_QRCODES_QUERY_INDEX] (state, offset: number) {
    state.query.index = (state.query.index ?? 0) + offset
  },

  [LOADED_ALL_QRCODES] (state) {
    state.didLoadAll = true
  },

  [RESET_LOADED_ALL_QRCODES] (state) {
    state.didLoadAll = false
  },

  [RESET_QRCODES_QUERY_INDEX] (state) {
    state.query.index = 0
  },

  [UPDATE_QRCODES] (state, qrCodes: QrCode[]) {
    state.elements = qrCodes
  },

  [UPDATE_QRCODES_TOTAL] (state, total: number) {
    state.total = total
  }
}

export default mutations
